import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '@4c/layout';

import { SourceType } from '../schema/reservationPayment';
import FormCheck from './FormCheck';
import LoadingIndicator from './LoadingIndicator';
import Small from './Small';

const Subtitle = styled(Small, null, "Subtitle", require("./PaymentType-Subtitle.module.scss"), "subtitle", "subtitle");

const PaymentSegment = styled(Layout, null, "PaymentSegment", require("./PaymentType-PaymentSegment.module.scss"), "payment-segment", "paymentSegment");

const Container = styled(Layout, null, "Container", require("./PaymentType-Container.module.scss"), "container", "container");

const propTypes = {};

function PaymentType({ onChange, value, canMakePayment, direction }) {
  if (canMakePayment == null) return <LoadingIndicator />;

  return (
    <Container pad={4} direction={direction}>
      {canMakePayment && (
        <PaymentSegment
          active={value === SourceType.PAYMENT_REQUEST}
          onClick={() => onChange(SourceType.PAYMENT_REQUEST)}
        >
          <FormCheck
            center
            inline
            type="radio"
            name="sourceType"
            checked={value === SourceType.PAYMENT_REQUEST}
            onChange={() => onChange(SourceType.PAYMENT_REQUEST)}
          >
            <FormattedMessage
              defaultMessage="Apple Pay"
              id="checkout.sourceType.applePay"
            />
          </FormCheck>
        </PaymentSegment>
      )}
      <PaymentSegment
        active={value === SourceType.CARD}
        onClick={() => onChange(SourceType.CARD)}
      >
        <FormCheck
          inline
          center
          type="radio"
          name="sourceType"
          checked={value === SourceType.CARD}
          onChange={() => {
            onChange(SourceType.CARD);
          }}
        >
          <FormattedMessage
            defaultMessage="Credit Card"
            id="checkout.sourceType.creditCard"
          />
        </FormCheck>
      </PaymentSegment>
      <PaymentSegment
        active={value === SourceType.ELECTRONIC_INVOICE}
        onClick={() => onChange(SourceType.ELECTRONIC_INVOICE)}
      >
        <FormCheck
          center
          inline
          type="radio"
          name="sourceType"
          checked={value === SourceType.ELECTRONIC_INVOICE}
          onChange={() => {
            onChange(SourceType.ELECTRONIC_INVOICE);
          }}
        >
          <span>
            <FormattedMessage
              defaultMessage="Electronic Quote"
              id="checkout.sourceType.invoice"
            />
            <Subtitle muted>
              <FormattedMessage
                defaultMessage="For enterprise payment"
                id="checkout.sourceType.invoiceSubtitle"
              />
            </Subtitle>
          </span>
        </FormCheck>
      </PaymentSegment>
    </Container>
  );
}

PaymentType.propTypes = propTypes;

export default PaymentType;
